import {FC} from "react";
import {Paragraph} from "../Paragraph";
import {Card} from "../Card";
import {useKeycloak} from "@react-keycloak/web";

export const UnauthenticatedPlaceholder: FC = () => {
  const {keycloak} = useKeycloak()
  return <div className={'bg-brand-900 text-white min-h-screen flex flex-col items-center justify-center'}>
    <div className={"max-w-md"}>
      <Card title={"Inloggen vereist."}>
        <Paragraph>Om de applicatie te gebruiken moet je ingelogd zijn. Je wordt automatisch doorverwezen. Als dit niet gebeurt kun je ook op 'inloggen' klikken.</Paragraph>
        <button className={"bg-brand-900 text-white font-medium rounded-xs px-2 py-2 w-full"} onClick={() => keycloak.login()}>Inloggen</button>
      </Card>
    </div>
  </div>
}
export const UnauthorizedPlaceholder: FC = () => {
  const {keycloak} = useKeycloak()
  return <div className={'bg-brand-900 text-white min-h-screen flex flex-col items-center justify-center'}>
    <div className={"max-w-md"}>
      <Card title={"Geen toegang."}>
        <Paragraph>Jouw toegangsniveau is niet toereikend om dit programma te kunnen gebruiken.</Paragraph>
        <button className={"bg-red-700 text-white font-medium rounded-xs px-2 py-2 w-full"} onClick={() => keycloak.logout()}>Uitloggen</button>
      </Card>
    </div>
  </div>
}
